import { CtaBlock, GetAirdateWrapper } from "@scrippsproduct/networks-ui-library"

const NETWORK = process.env.REACT_APP_NETWORK
const SCHEDULE_ENDPOINT = process.env.REACT_APP_SCHEDULE_V2

const SUPPORT_LINK = 'https://support.laff.com/support/home'

const homepage = {
    data: new Map([
        ['slides', [
            {  
                layout: 'ShowSlide',
                props: {
                    series: {
                        title: 'Hawaii Five-O',
                        bannerImage: {
                            image: {
                                publicUrl: 'https://iontelevision.com/static/programs/shows/hawaii-five-0/original/slide-63e27faf1f631-d821eaa11f6ac7a592f08c88a5d58add4c89891b.jpg'
                            }
                        },
                        slug: 'hawaii-five-o',
                        seriesPrefix: 'HFO',
                    },
                    titlePosition: 'left',
                    titleColor: '#fff',
                },
            },
            {
                layout: 'ShowSlide',
                props: {
                    series: {
                        title: 'Law & Order: SVU',
                        bannerImage: {
                            image: {
                                publicUrl: 'https://iontelevision.com/static/programs/shows/law-order-svu/original/slide-63d3f792ae3ed-e6ffd5de50a0d44c7f1160ebd67cb21ed7d8c0a7.jpg'
                            }
                        },
                        slug: 'law-order-svu',
                        seriesPrefix: 'SVU',
                    },
                    titlePosition: 'left',
                    titleColor: '#fff',
                },
            },
            {
                title: "NCIS",
                layout: 'ShowSlide',
                props: {
                    series: {
                        title: 'NCIS',
                        bannerImage: {
                            image: {
                                publicUrl: 'https://iontelevision.com/static/programs/shows/ncis/original/slide-63e2806af1d15-4e89ac49ebf330b02b4c9ccf786e258b6f240b24.jpg'
                            }
                        },
                        slug: 'ncis',
                        seriesPrefix: 'NCS',
                    },
                    titlePosition: 'left',
                    titleColor: '#fff',
                },
            },
            // {
            //     title: 'FBI Promo',
            //     layout: 'Figure',
            //     cells: [
            //         {
            //             props: {
            //                 images: [
            //                     {
            //                         url: 'https://iontelevision.com/static/ion-tv-slides/original/carousel-slide-63d2deda7e435-0ee1c2fcc6ee5d812622f7995ddb26f9b0219544.jpg',
            //                     altText: 'FBI Mondays at 7 eastern, 6 central',
            //                     caption: '',
            //                     },                                
            //                 ]
            //             }
            //         }
            //     ],
            //     Slide: {
            //         image: {
            //             publicUrl: "https://iontelevision.com/static/ion-tv-slides/original/carousel-slide-63d2deda7e435-0ee1c2fcc6ee5d812622f7995ddb26f9b0219544.jpg",
            //         },
            //         altText: 'FBI Monday 7/6c',
            //     },
            // },
            {
                title: "Criminal Minds",
                layout: 'ShowSlide',
                props: {
                    series: {
                        title: 'Criminal Minds',
                        bannerImage: {
                            image: {
                                publicUrl: 'https://iontelevision.com/static/programs/shows/criminal-minds/original/slide-63ea49f73fe5c-b41017b182966c584923c2807327af5b6e4ee8c6.jpg'
                            }
                        },
                        slug: 'criminal-minds',
                        seriesPrefix: 'CMD',
                    },
                    titlePosition: 'left',
                    titleColor: '#fff',
                },
            },
            {
                title: "Chicago Fire",
                layout: 'ShowSlide',
                props: {
                    series: {
                        title: 'Chicago Fire',
                        bannerImage: {
                            image: {
                                publicUrl: 'https://iontelevision.com/static/programs/shows/chicago-fire/original/slide-63c6e637eba34-ff87e715f79c7d90bf318ae34b4abd2867641258.jpg'
                            }
                        },
                        slug: 'chicago-fire',
                        seriesPrefix: 'CFD',
                    },
                    titlePosition: 'left',
                    titleColor: '#fff',
                },
            },
        ]],
        ['featuredShows', [
            {
                title: 'Slide 1',
                layout: 'ImageCard',
                props: {
                    id: 1,
                    image: {
                        url: "https://iontelevision.com/static/ion-tv-slides/small/carousel-slide-63ff5cf1948f4-bf6a5d58f6c76807e6dedf643bc424f243e8f6ed.png",
                        altText: "Blue Bloods",
                        aspectRatio: 0.6561461794019934
                    },
                    content: <GetAirdateWrapper NETWORK={NETWORK} SCHEDULE_ENDPOINT={SCHEDULE_ENDPOINT} seriesPrefix='BBD' separatorType='pipe' />,
                    cta: {
                        href: 'show/blue-bloods',
                        type: 'internal-link',
                    },
                    fullCardClickable: true,
                } 
            },
            {
                layout: 'ImageCard',
                props: {
                    id: 2,
                    image: {
                        url: "https://iontelevision.com/static/ion-tv-slides/small/carousel-slide-63ff5d3b489b8-253a584a1b1ce08941cf414ba82c1513c57e8741.png",
                        altText: "Law & Order: SVU",
                        aspectRatio: 0.6561461794019934,
                    },
                    content: <GetAirdateWrapper seriesPrefix='SVU' separatorType='pipe' />,
                    cta: {
                        href: 'show/law-order-svu',
                        type: 'internal-link',
                    },
                    fullCardClickable: true,
                } 
            },
            {
                layout: 'ImageCard',
                props: {
                    id: 3,
                    image: {
                        url: "https://iontelevision.com/static/ion-tv-slides/small/carousel-slide-63ff5d6e6712e-50709922828624bfc1adeaa1822e99b7f5d53b7a.png",
                        altText: "FBI",
                        aspectRatio: 395/602,
                    },
                    content: <GetAirdateWrapper NETWORK={NETWORK} SCHEDULE_ENDPOINT={SCHEDULE_ENDPOINT} seriesPrefix='SVU' separatorType='pipe' />,
                    cta: {
                        href: 'show/fbi',
                        type: 'internal-link',
                    },
                    fullCardClickable: true,
                } 
            },
            {
                layout: 'ImageCard',
                props: {
                    id: 4,
                    image: {
                        url: "https://iontelevision.com/static/ion-tv-slides/small/carousel-slide-63ff5d9c990cd-6a956018f29056a1a8a2d0f8c7a876b7d7a26c16.png",
                        altText: "Chicago Fire",
                        aspectRatio: 0.6561461794019934
                    },
                    content: <GetAirdateWrapper seriesPrefix='CFD' separatorType='pipe' NETWORK={NETWORK} SCHEDULE_ENDPOINT={SCHEDULE_ENDPOINT} />,
                    cta: {
                        href: 'show/chicago-fire',
                        type: 'internal-link',
                    },
                    fullCardClickable: true,
                },
            },
            {
                title: 'Slide 2',
                layout: 'ImageCard',
                props: {
                    id: 5,
                    image: {
                        url: "https://iontelevision.com/static/ion-tv-slides/small/carousel-slide-63ff5dc819ab7-324bfbea957218a9cd8980c56e455c6025e0bf7c.png",
                        altText: "Criminal Minds",
                        aspectRatio: 0.6561461794019934
                    },
                    content: <GetAirdateWrapper seriesPrefix='CMD' separatorType='pipe' NETWORK={NETWORK} SCHEDULE_ENDPOINT={SCHEDULE_ENDPOINT}/>,
                    cta: {
                        href: 'show/criminal-minds',
                        type: 'internal-link',
                    },
                    fullCardClickable: true,
                },
            },
            {
                layout: 'ImageCard',
                props: {
                    id: 6,
                    image: {
                        url: "https://iontelevision.com/static/programs/shows/ncis/small/pod-63ff5f4996a9e-de6d375b095074e5096952f998c4617bf4d7939f.png",
                        altText: "NCIS",
                        aspectRatio: 0.6561461794019934
                    },
                    content: <GetAirdateWrapper seriesPrefix='NCS' separatorType='pipe' NETWORK={NETWORK} SCHEDULE_ENDPOINT={SCHEDULE_ENDPOINT} />,
                    cta: {
                        href: 'show/ncis',
                        type: 'internal-link',
                    },
                    fullCardClickable: true,
                } 
            },
        ]],
        ['promotions', [
            {
                "id": 1,
                "image": {
                    "url": "https://iontelevision.com/static/global/redesign/celebrating-heroes.png",
                    "altText": "",
                },
                "title": "ION Celebrates Heroes this Veteran's Day",
                "content": "\"Celebrating Heroes\" recognizes the difference makers among us, including first responders, active duty military, and some other stuff that should be cut off pretty soon.",
                "cta": {
                    "type": "external-link",
                    "label": "",
                    "href": "#",
                    "position": "end",
                    "relatedResourceId": "10124241"
                }
            },
            {
                "id": 2,
                "image": {
                "url": "https://iontelevision.com/static/global/redesign/new-episodes.png",
                "altText": "",
                },
                "title": "New Episodes Premiering This Month",
                "content": "She's fast enough for you, old man. What's the cargo? Only passengers.",
                "cta": {
                    "type": "play-video",
                    "label": "",
                    "href": "#",
                    "position": "end",
                    "relatedResourceId": "6320926365112"
                }
            },
            {
                "id": 3,
                "image": {
                    "url": "https://iontelevision.com/static/global/redesign/celebrating-heroes.png",
                    "altText": "",
                },
                "title": "ION Celebrates Heroes this Veteran's Day",
                "content": "\"Celebrating Heroes\" recognizes the difference makers among us, including first responders, active duty military, and some other stuff that should be cut off pretty soon.",
                "cta": {
                    "type": "external-link",
                    "label": "",
                    "href": "#",
                    "position": "end",
                    "relatedResourceId": "10124241"
                }
            },
        ]],
        ['moreFroms', [
            {
                "image": {
                    "url": "https://ewscripps.brightspotcdn.com/26/73/379c98c441509f5dd25348359d44/ion-mystery-slide-image.png",
                    "altText": "",
                    "caption": "<h2 class=\"h4\">New Episodes Premiering This Month</h2><p>She's fast enough for you, old man. What's the cargo? Only passengers. Myself, the boy, two droids, and no questions asked. What is it? Some kind of local trouble? Let's just say we'd like to avoid any Imperial entanglements.</p>"
                },
                "overlayContent": {
                    "titleImageUrl": "https://ewscripps.brightspotcdn.com/8a/c8/bfedb7cf47009efead2dbb7bb328/ion-mystery-logo-orange-white-1.png",
                    "component": "./../block/CtaBlock",
                    "title": "ION Mystery",
                    "content": "Television's most Binge-worthy thrillers, docuseries and originals",
                    "cta": {
                        "type": "external-link",
                        "label": "Learn More",
                        "href": "https://ionmystery.com",
                    },
                    btnGradientStartColor: "var(--theme-color-200)",
                    btnGradientEndColor: "var(--theme-color-100)",
                },
                "cta": {},
                classname: 'ion-mystery-promo'
            },
            {
                "image": {
                    "url": "https://ewscripps.brightspotcdn.com/c0/e0/d970bbb449f3a61db4387a9c79ad/ion-plus-promo.png",
                    "altText": "",
                    "caption": ""
                },
                "overlayContent": {
                    "component": "./../block/CtaBlock",
                    "title": "ION Plus",
                    titleImageUrl: "",
                    "content": "More shows, more drama, more reasons to binge!",
                    "cta": {
                        "type": "external-link",
                        "label": "Learn More",
                        "href": "https://ionplustv.com",
                    },
                    "btnGradientStartColor": "var(--theme-color-200)",
                    "btnGradientEndColor": "var(--theme-color-100)",
                },
                "cta": {},
                classname: 'ion-plus-promo',
            },
        ]],
        ['brandSlides', [
            {
                title: 'Slide 1',
                layout: 'TwoColumnSlide',
                props: {
                    columnOneContent: <CtaBlock 
                        title={'ION Mystery'}
                        content={`Television's most Binge-worthy thrillers, docuseries and originals`}
                        cta={{
                            label: ``,
                            href: `https://ionmystery.com`,
                            type: 'external-link',
                        }}
                        titleImageUrl={`https://iontelevision.com/static/global/ION-Mystery_Logo-White.svg`}
                        type={'external-link'}
                        btnGradientStartColor={`#000`}
                        btnGradientEndColor={`#555`} />,
                    columnTwoContent: `<img src="https://iontelevision.com/static/global/ION-Mystery-Slide-Image.png" />`,
                },
            },
            {
                title: 'Slide 1',
                layout: 'TwoColumnSlide',
                props: {
                    columnOneContent: <CtaBlock 
                        title={'ION Plus'}
                        content={`More shows, more drama, more reasons to binge!`}
                        cta={{
                            label: ``,
                            href: `https://ionplustv.com`,
                            type: 'external-link',
                        }}
                        titleImageUrl={`https://iontelevision.com/static/global/corp-logos/IONPlus-logo_white1.svg`}
                        type={'external-link'}
                        btnGradientStartColor={`#000`}
                        btnGradientEndColor={`#555`} />,
                    columnTwoContent: `<img src="https://iontelevision.com/static/global/redesign/ion-plus-promo.png" />`,
                },
            },
        ]],
        ['onNow', {
            episode: {
                series: {
                    logo: {
                        black: {
                            url: "https://iontelevision.com/static/global/redesign/Logo-NCIS.png"
                        },
                        color: {
                            url: "https://iontelevision.com/static/global/redesign/Logo-NCIS.png"
                        },
                        dimensions: 3.7593984962406015,
                    },
                    images: {
                        onNow: {
                            back: {
                                url: 'https://iontelevision.com/static/global/redesign/on-now-bkgd.png',
                            },
                            front: {
                                url: 'https://iontelevision.com/static/global/redesign/leroy-gibbs.png'
                            }
                        }
                    },        
                    primary_color: '#628e84',
                    secondary_color: '#364440',
                    slug: 'ncis',
                    name: "NCIS", 
                },
                season: 12,
                number: "02",
                name: "Kill The Messenger",
            },
            airdate: "2023-01-12 13:00:00",
        }],
    ]),
}

const header = {
    data: new Map([
        ['menuLinks', 
            [
                {
                    type:`internal-link`,
                    href: `/schedule`,
                    label: `Schedule`,
                },
                {
                    type:`internal-link`,
                    href: `/find-us`,
                    label: `Find Us`,
                },
            ]
        ],
        ['logoItems', 
            [
                {
                    image: {
                        url: `https://ewscripps.brightspotcdn.com/dims4/default/4028f74/2147483647/strip/true/crop/134x80+0+0/resize/134x80!/quality/90/?url=http%3A%2F%2Fewscripps-brightspot.s3.amazonaws.com%2F65%2Fe0%2Fb7be42e94ea89a5347f6c8dd9e45%2Flaff-more-logo.png`,
                        width: 300,
                        height: 119,
                        altText: `Laff More Logo, go to Laff More page`,
                    },
                    href: `/laffmore`,
                    target: `_blank`,
                    height: 2.2,
                    baselineAdjustment: -0.9,
                    text: 'ION Mystery',
                },
            ]
        ]
    ])
}

const footer = {
    data: new Map([
        ['navSections', 
            [
                {
                    "title": "Site Navigation",
                    "links": [
                        {
                            "href": "/schedule",
                            "type": "internal-link",
                            "label": "Schedule"
                        },
                        {
                            "href": "/find-us",
                            "type": "internal-link",
                            "label": "Find Us"
                        }
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Networks",
                    "links": [
                        {
                            "href": "https://laff.com",
                            "type": "internal-link",
                            "label": "Laff"
                        },
                        {
                            "href": "https://laff.com/laffmore",
                            "type": "external-link",
                            "label": "Laff More"
                        },
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Privacy & Terms",
                    "links": [
                        {
                            "href": "https://scripps.com/privacy-policy",
                            "type": "external-link",
                            "label": "Privacy Policy"
                        },
                        {
                            "href": "/terms-of-use",
                            "type": "internal-link",
                            "label": "Terms of Use"
                        },
                        {
                            "href": "http://scripps.com/privacy-center",
                            "type": "external-link",
                            "label": "Privacy Center"
                        },
                        {
                            "href": "#",
                            "type": "internal-link",
                            "label": "Do Not Sell My Info",
                            "classname": "privacy-preferences-trigger",
                        },
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Information",
                    "links": [
                        {
                            "href": "https://support.laff.com/support/solutions",
                            "type": "external-link",
                            "label": "Help/FAQs"
                        },
                        {
                            "href": SUPPORT_LINK,
                            "type": "external-link",
                            "label": "Contact Us"
                        },
                    ],
                    "classname": "footer-nav"
                }
            ]
        ],
        ['socialLinks',
            [
                {
                    platform: 'facebook',
                    url: 'https://www.facebook.com/lafftvnetwork?fref=ts',
                },
                {
                    platform: 'twitter',
                    url: 'https://twitter.com/laff',
                },
                {
                    platform: 'instagram',
                    url: 'https://www.instagram.com/lafftv',
                },
                {
                    platform: 'tiktok',
                    url: 'https://www.tiktok.com/@laff.tv',
                },
            ]
        ],
    ])  
}

const laffmoreFooter = {
    data: new Map([
        ['navSections', 
            [
                {
                    "title": "Site Navigation",
                    "links": [
                        {
                            "href": "/",
                            "type": "internal-link",
                            "label": " Laff Home"
                        },
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Privacy & Terms",
                    "links": [
                        {
                            "href": "https://scripps.com/privacy-policy",
                            "type": "external-link",
                            "label": "Privacy Policy"
                        },
                        {
                            "href": "https://scripps.com/user-agreement/",
                            "type": "extrenal-link",
                            "label": "Terms of Use"
                        },
                        {
                            "href": "https://scripps.com/privacy-center",
                            "type": "external-link",
                            "label": "Privacy Center"
                        }
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Information",
                    "links": [
                        {
                            "href": "https://support.laff.com/support/home",
                            "type": "external-link",
                            "label": "Contact Us"
                        },
                        {
                            "href": "https://support.laff.com/support/solutions",
                            "type": "external-link",
                            "label": "Frequently Asked Questions"
                        },
                    ],
                    "classname": "footer-nav"
                }
            ]
        ],
        ['socialLinks',
            [
                {
                    platform: 'facebook',
                    url: 'https://www.facebook.com/lafftvnetwork?fref=ts',
                },
                {
                    platform: 'twitter',
                    url: 'https://twitter.com/laff',
                },
                {
                    platform: 'instagram',
                    url: 'https://www.instagram.com/lafftv',
                },
                {
                    platform: 'tiktok',
                    url: 'https://www.tiktok.com/@laff.tv',
                },
            ]
        ],
    ])  
}

const resources = new Map([
    ['header', header],
    ['footer', footer],
    ['laffmore-footer', laffmoreFooter],
    ['homepage', homepage],
])

export {
    resources,
    SUPPORT_LINK,
}